import { render } from "./CriacaoAtivosEmMassa.vue?vue&type=template&id=d842796e&scoped=true"
import script from "./CriacaoAtivosEmMassa.vue?vue&type=script&lang=js"
export * from "./CriacaoAtivosEmMassa.vue?vue&type=script&lang=js"

import "./CriacaoAtivosEmMassa.vue?vue&type=style&index=0&id=d842796e&scoped=true&lang=css"

import exportComponent from "/woodpecker/src/github.com/Multpex/multpex.front.gestao/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d842796e"]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QTabPanels from 'quasar/src/components/tab-panels/QTabPanels.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QPage,QTabs,QTab,QTabPanels,QTabPanel});
